module.exports = __webpack_public_path__ + "img/grip-horizontal.dd43f707.svg";